import * as z from "zod";
//#region src/__generated__/viewer/markupController/zod/jsonNodeSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const jsonNodeSchema = z.object({});
//#endregion
//#region src/__generated__/viewer/markupController/zod/viewSizeSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const viewSizeSchema = z.object({
	aspect: z.number().nullish(),
	fov: z.int().nullish(),
	height: z.int().nullish(),
	width: z.int().nullish()
});
//#endregion
//#region src/__generated__/viewer/markupController/zod/markupDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const markupDtoSchema = z.object({
	authorId: z.uuid(),
	cameraPos: z.array(z.number()).min(3).max(3).optional(),
	date: z.iso.datetime().optional(),
	id: z.uuid().optional(),
	index: z.int().optional(),
	isCritical: z.boolean(),
	isProposedAsTypical: z.boolean(),
	isTypical: z.boolean(),
	markups: jsonNodeSchema.optional(),
	modelIds: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional(),
	name: z.string().optional(),
	priority: z.enum([
		"MAJOR",
		"NORMAL",
		"LOW"
	]).optional(),
	projectId: z.uuid(),
	targetPos: z.array(z.number()).min(3).max(3).optional(),
	typicalMarkupId: z.uuid().optional(),
	viewSize: viewSizeSchema.optional()
});
//#endregion
//#region src/__generated__/viewer/markupController/zod/addMarkupSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const addMarkupPathProjectIdSchema = z.uuid();
const addMarkupHeaderXUserIdSchema = z.uuid();
const addMarkupStatus200Schema = markupDtoSchema;
const addMarkupResponseSchema = addMarkupStatus200Schema;
const addMarkupDataSchema = markupDtoSchema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/deleteMarkupSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteMarkupPathMarkupIdSchema = z.uuid();
const deleteMarkupStatus200Schema = z.unknown();
const deleteMarkupResponseSchema = deleteMarkupStatus200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/exportMarkupsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportMarkupsStatus200Schema = z.instanceof(File);
const exportMarkupsResponseSchema = exportMarkupsStatus200Schema;
const exportMarkupsDataSchema = z.array(z.uuid());
//#endregion
//#region src/__generated__/viewer/markupController/zod/getAll3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAll3PathProjectIdSchema = z.uuid();
const getAll3Status200Schema = z.array(markupDtoSchema);
const getAll3ResponseSchema = getAll3Status200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/dataBufferSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dataBufferSchema = z.object({});
//#endregion
//#region src/__generated__/viewer/markupController/zod/getAllMarkupByModelIdsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAllMarkupByModelIdsStatus200Schema = z.array(dataBufferSchema);
const getAllMarkupByModelIdsResponseSchema = getAllMarkupByModelIdsStatus200Schema;
const getAllMarkupByModelIdsDataSchema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
//#endregion
//#region src/__generated__/viewer/markupController/zod/getAllMarkupsIsProposedAsTypicalSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAllMarkupsIsProposedAsTypicalStatus200Schema = z.array(dataBufferSchema);
const getAllMarkupsIsProposedAsTypicalResponseSchema = getAllMarkupsIsProposedAsTypicalStatus200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/getByIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getByIdPathMarkupIdSchema = z.uuid();
const getByIdStatus200Schema = markupDtoSchema;
const getByIdResponseSchema = getByIdStatus200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/markupCountDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const markupCountDtoSchema = z.object({ markupCount: z.int().nullish() });
//#endregion
//#region src/__generated__/viewer/markupController/zod/getCountForModelSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCountForModelPathModelIdSchema = z.uuid();
const getCountForModelStatus200Schema = markupCountDtoSchema;
const getCountForModelResponseSchema = getCountForModelStatus200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/getForModelSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getForModelPathModelIdSchema = z.uuid();
const getForModelStatus200Schema = z.array(markupDtoSchema);
const getForModelResponseSchema = getForModelStatus200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/markupScreenshotDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const markupScreenshotDtoSchema = z.object({ imageBase64: z.string() });
//#endregion
//#region src/__generated__/viewer/markupController/zod/getScreenshotSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getScreenshotPathMarkupIdSchema = z.uuid();
const getScreenshotStatus200Schema = markupScreenshotDtoSchema;
const getScreenshotResponseSchema = getScreenshotStatus200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/getScreenshotsByModelIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getScreenshotsByModelIdPathModelIdSchema = z.uuid();
const getScreenshotsByModelIdStatus200Schema = z.object({}).catchall(z.string());
const getScreenshotsByModelIdResponseSchema = getScreenshotsByModelIdStatus200Schema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/updateMarkupSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateMarkupPathMarkupIdSchema = z.uuid();
const updateMarkupStatus200Schema = markupDtoSchema;
const updateMarkupResponseSchema = updateMarkupStatus200Schema;
const updateMarkupDataSchema = markupDtoSchema;
//#endregion
//#region src/__generated__/viewer/markupController/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	author: z.uuid(),
	baseName: z.string(),
	createdAt: z.iso.datetime(),
	ext: z.string().nullish(),
	id: z.uuid(),
	isDeleted: z.boolean(),
	modifiedAt: z.iso.datetime(),
	parentId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	previewId: z.uuid().nullish(),
	size: z.int(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"KNOWLEDGE_BASE",
		"REPORT_GENERATION_CACHE"
	]),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REPORT_GENERATION_CACHE",
		"PDF_DOCUMENT",
		"PDF_DOCUMENT_PREVIEW"
	]),
	version: z.int(),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1")
});
//#endregion
//#region src/__generated__/viewer/markupController/zod/imageUploadResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const imageUploadResponseSchema = z.object({ fileMeta: fileMetaDtoSchema });
//#endregion
//#region src/__generated__/viewer/markupController/zod/uploadScreenshotSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uploadScreenshotPathMarkupIdSchema = z.uuid();
const uploadScreenshotHeaderXUserIdSchema = z.uuid();
const uploadScreenshotStatus200Schema = imageUploadResponseSchema;
const uploadScreenshotResponseSchema = uploadScreenshotStatus200Schema;
const uploadScreenshotDataSchema = markupScreenshotDtoSchema;
//#endregion
export { getAllMarkupsIsProposedAsTypicalStatus200Schema as A, exportMarkupsStatus200Schema as B, getCountForModelResponseSchema as C, getByIdResponseSchema as D, getByIdPathMarkupIdSchema as E, getAll3PathProjectIdSchema as F, addMarkupHeaderXUserIdSchema as G, deleteMarkupResponseSchema as H, getAll3ResponseSchema as I, addMarkupStatus200Schema as J, addMarkupPathProjectIdSchema as K, getAll3Status200Schema as L, getAllMarkupByModelIdsResponseSchema as M, getAllMarkupByModelIdsStatus200Schema as N, getByIdStatus200Schema as O, dataBufferSchema as P, exportMarkupsDataSchema as R, getCountForModelPathModelIdSchema as S, markupCountDtoSchema as T, deleteMarkupStatus200Schema as U, deleteMarkupPathMarkupIdSchema as V, addMarkupDataSchema as W, viewSizeSchema as X, markupDtoSchema as Y, jsonNodeSchema as Z, getScreenshotStatus200Schema as _, uploadScreenshotStatus200Schema as a, getForModelResponseSchema as b, updateMarkupDataSchema as c, updateMarkupStatus200Schema as d, getScreenshotsByModelIdPathModelIdSchema as f, getScreenshotResponseSchema as g, getScreenshotPathMarkupIdSchema as h, uploadScreenshotResponseSchema as i, getAllMarkupByModelIdsDataSchema as j, getAllMarkupsIsProposedAsTypicalResponseSchema as k, updateMarkupPathMarkupIdSchema as l, getScreenshotsByModelIdStatus200Schema as m, uploadScreenshotHeaderXUserIdSchema as n, imageUploadResponseSchema as o, getScreenshotsByModelIdResponseSchema as p, addMarkupResponseSchema as q, uploadScreenshotPathMarkupIdSchema as r, fileMetaDtoSchema as s, uploadScreenshotDataSchema as t, updateMarkupResponseSchema as u, markupScreenshotDtoSchema as v, getCountForModelStatus200Schema as w, getForModelStatus200Schema as x, getForModelPathModelIdSchema as y, exportMarkupsResponseSchema as z };

//# sourceMappingURL=uploadScreenshotSchema.js.map